import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ValuesSection from './components/ValuesSection';
import PortfolioPreview from './components/PortfolioPreview';
import StatsSection from './components/StatsSection';
import StorefinderSection from './components/StorefinderSection';
import CtaSection from './components/CtaSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ValuesSection />
        <StatsSection />
        <PortfolioPreview />
        <StorefinderSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}
